export default "__VITE_ASSET__DqLsurvO__"